import { ReduxService } from 'dashboard-services/services';

import { compareDataScienceActions } from 'actions/modules/datascience';

export const compareInitial = {
  isOpen: false,

  leftPipeline: undefined,
  leftJobId: undefined,

  useCurrentPipelineAsRight: false,
  rightPipeline: undefined,

  localTasks: {},
}

export default (state = compareInitial, action) => {
  switch (action.type) {
    case compareDataScienceActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case compareDataScienceActions.ON_CHANGE_LOCAL_TASKS_PARAM:
      if(state.localTasks[action.taskId]) {
        return ReduxService.updateObject(state, { 
          localTasks: ReduxService.updateObject(state.localTasks, { 
            [action.taskId]: ReduxService.updateObject(state.localTasks[action.taskId], 
              { 
                params: state.localTasks[action.taskId].params.updateInList({ value: action.value  }, state.localTasks[action.taskId].params.findIndex(p => p.name === action.name))
              }
            ) 
          }) 
        })
      }
      return state;
    default:
      return state;
  }
}